import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UspItem',
  props: {
    whiteText: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { whiteText?: boolean }


const usp = computed<IUsp>(() => store.getters['app/usp']);

const hasIcon = computed<boolean>(() => !!usp.value.whiteIcon || !!usp.value.blackIcon);
const hasWhiteIcon = computed<boolean>(() => {
    if (usp.value.whiteIcon && !usp.value.blackIcon) {
        return true;
    }
    if (usp.value.blackIcon && !usp.value.whiteIcon) {
        return false;
    }
    return props.whiteText;
});

return { __sfc: true,props, usp, hasIcon, hasWhiteIcon }
}

})